import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { SELLER, SELLER_SITE_PATH, WEBSITE_PATH, windowPostMessage } from "../common/common";
import { User } from "../models/messaging";
import Connector from "../signalr/signalr-connection";

interface DataProps {
  senderDetails?: User;
  senderID?: string;
  receiverDetails?: User;
  conversationID?: string;
  messageType: number;
  noChange?: boolean;
}
const ConnectUser = () => {
  const [searchParam] = useSearchParams();
  const userConnection = Connector(searchParam.get("userid"));
  const groupConnection = Connector("groupConnections", null, searchParam.get("userid"));

  const handleWindowMessageReceived = (event: any) => {
    const sitePath: string = SELLER ? SELLER_SITE_PATH : WEBSITE_PATH;
    if (event.origin && event.origin.includes(sitePath.slice(0, -1))) {
      const data = event.data;
      switch (data.type) {
        case "updateFollowingStatus3rdParty":
          const params: DataProps = {
            messageType: 2,
            noChange: data.noChange,
            senderID: data.senderID,
          };
          userConnection.newMessage(data.status.toString(), JSON.stringify(params), data.receiverID);
          break;
        case "updateEntityStatus":
          const params1: any = {
            action: "mute",
            status: data.status,
          };
          groupConnection && groupConnection.newMessage(JSON.stringify(params1), data.entityCodeNum, "groupConnections");
          break;
      }
    }
  };

  const onGroupMessageReceived = (entityCodeNum: string, action: string) => {
    let status: boolean = true;
    if (action !== "leave" && action !== "join") {
      const mainAction = JSON.parse(action);
      action = mainAction.action;
      status = mainAction.status;
    }
    windowPostMessage({ type: "updateConnectivityStatus", action: action, chatID: entityCodeNum, status: status }, WEBSITE_PATH);
  };

  groupConnection.onMessageReceived = onGroupMessageReceived;

  const onMessageReceived = (data: string, currMessage: string) => {
    const parsedData: DataProps = JSON.parse(data);
    switch (parsedData.messageType) {
      case 1:
        windowPostMessage({ type: "connection", message: currMessage, conversationID: parsedData.conversationID, senderDetails: parsedData.senderDetails, receiverDetails: parsedData.receiverDetails, senderUserID: parsedData.senderID }, WEBSITE_PATH);
        break;
      case 2:
        windowPostMessage({ type: "clearSuggestion" }, WEBSITE_PATH);
        windowPostMessage({ type: "updateFollowStatus3rdParty", status: parseInt(currMessage), senderID: parsedData.senderID, noChange: parsedData.noChange }, WEBSITE_PATH);
        break;
      case 3:
        windowPostMessage({ type: "updateTypingStatus", senderID: parsedData.senderID, isTyping: currMessage === "false" }, WEBSITE_PATH);
        break;
      case 4:
        windowPostMessage({ type: "updateUserInboxMessage", senderID: parsedData.senderID, isNewMessage: "true" }, WEBSITE_PATH);
        break;
    }
  };
  userConnection.onMessageReceived = onMessageReceived;

  useEffect(() => {
    window.addEventListener("message", handleWindowMessageReceived);
    return () => window.removeEventListener("message", handleWindowMessageReceived);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default ConnectUser;
